import { defineComponent, getCurrentInstance, markRaw } from 'vue';
import bus from '@platform/bus';
import { routerKey } from 'vue-router';
import { getRouter } from '@platform/boot';
import MyTooltip from '@platform/components/ui/my-tooltip.vue';

let QuasarHelper;

const RendererVue3Fix = {
    provide() {
        return {
            [routerKey]: getRouter(),
        };
    },
    beforeMount() {
        const app = getCurrentInstance();
        app.proxy.$q = QuasarHelper;
        app.appContext.config.globalProperties = {
            ...app.appContext.config.globalProperties,
            $q: QuasarHelper,
            $bus: bus,
        };
    },
};

/**
 * @function fixVue3Components
 * @param {T} component
 * @param {any[]} additionalMixins
 * @returns {T}
 */
function fixVue3Components(component, additionalMixins = []) {
    const configuredComponent = {
        ...component,
        mixins: Array.isArray(component.mixins)
            ? [RendererVue3Fix, ...additionalMixins, ...component.mixins]
            : [RendererVue3Fix, ...additionalMixins],
    };

    if (configuredComponent.components) {
        for (const componentDef in configuredComponent.components) {
            if (!configuredComponent.components.hasOwnProperty(componentDef)) continue;
            if (!configuredComponent.components[componentDef].__v_skip) {
                configuredComponent.components[componentDef] = markRaw(configuredComponent.components[componentDef]);
            }
        }
        configuredComponent.components.MyTooltip = MyTooltip;
    } else {
        configuredComponent.components = { MyTooltip };
    }

    return defineComponent(configuredComponent);
}

export function setQuasarHelper($q) {
    QuasarHelper = $q;
    if (QuasarHelper.iconMapFn === undefined) QuasarHelper.iconMapFn = null;
}

export function getQuasarHelper() {
    return QuasarHelper;
}

export default fixVue3Components;
